'use strict';

module.exports = (function() {

   return {
      add: add,
      multiplyByScalar: multiplyByScalar,
      multiply: multiply,
      divide: divide,
      middleValue: middleValue,
      format: format,
      parse: parse,
      possibility: possibility,
      necessity: necessity,
   }

   function add(f1, f2) {
      return {
         d1: f1.d1 + f2.d1,
         d2: f1.d2 + f2.d2,
         dt1: f1.dt1 + f2.dt1,
         dt2: f1.dt2 + f2.dt2,
         h: Math.max(f1.h, f2.h)
      }
   }

   function multiplyByScalar(f, c) {
      return {
         d1: f.d1 * c,
         d2: f.d2 * c,
         dt1: f.dt1 * c,
         dt2: f.dt2 * c,
         h: f.h,
      }
   }

   function divide(f1, f2) {
      return {
         d1: f1.d1 / f2.d1,
         d2: f1[1] / f2.d2,
         dt1: (f1.d1 * f2.dt2 + f1.dt1 * f2.d2) / (f2.d2 * (f2.dt2 + f2.d2)),
         dt2: (f2.d1 * f1.dt2 + f1[1] * f2.dt1) / (f2.d1 * (f2.d1 - f2.dt1)),
         h: Math.max(f1.h, f2.h),
      }
   }

   function multiply(f1, f2) {
      return {
         d1: f1.d1 * f2.d1,
         d2: f1.d2 * f2.d2,
         dt1: f2.dt1 * (f1.d1 - f1.dt1) + f1.dt1 * f2.d1,
         dt2: f1.dt2 * f2.dt2 + (f1.d2 + f1.dt2) * f2.dt2,
         h: Math.max(f1.h, f2.h)
      }
   }

   function middleValue(f) {
      return (f.d1 + f.d2) / 2.0;
   }

   function format(f) {
      let mid = middleValue(f)
      let s1 = f.d1 - f.dt1
      let s2 = f.d2 + f.dt2
      s1 = Math.max(s1, 0.0)
      s2 = Math.max(s2, 0.0)

      let mval = Math.min(Math.abs(f.d1), Math.abs(f.d2))
      let df
      if (mval >= 10) {
         df = function(x) {
            return Math.round(x) + ''
         }
      } else {
         df = function(x) {
            return x.toFixed(1)
         }
      }

      if (s2 >= Infinity && s1 <= -Infinity) {
         return "?"
      }
      if (s2 >= Infinity) {
         if (s1 < Infinity) {
            return ">" + df(s1)
         } else {
            return "+infini"
         }
      }
      if (s1 <= -Infinity) {
         if (s2 > -Infinity) {
            return "<" + df(s2)
         } else {
            return "-infini"
         }
      }
      if ((f.d2 - f.d1 <= 0.041 * mid) && (s2 - s1 <= 0.11 * mid)) {
         return df(mid)
      }
      if ((f.d2 - f.d1 <= 0.11 * mid) && (s2 - s1 <= 0.21 * mid)) {
         return "~" + df(mid)
      }
      if ((f.d2 - f.d1 <= 0.21 * mid) && (s2 - s1 <= 0.41 * mid)) {
         return "~~" + df(mid)
      }
      return "~" + df(f.d1) + "-" + df(f.d2)
   }


   // parse string into fuzzy number
   // return null when not parsable
   // ex: "~120" -> [114.0, 126.0, 6.0, 6.0, 0]

   function parse(text) {
      text = text.trim();
      let d1
      let d2
      let s1
      let s2
      let q
      try {
         if (text === '?') {
            return { d1: 0, d2: Infinity, dt1: Infinity, dt2: Infinity, h: 0 }
         } else if (text[0] === '~') {
            if (text[1] === '~') {
               // ex: ~~125
               q = parseFloat(text.substring(2))
               if (isNaN(q)) {
                  throw new Error("Not a number")
               }
               d1 = q * 0.9
               d2 = q * 1.1
               s1 = q * 0.8
               s2 = q * 1.2
               return { d1: d1, d2: d2, dt1: d1 - s1, dt2: s2 - d2, h: 0 }
            } else if (text.substring(1).indexOf('-') !== -1) {
               // ex: ~100-150
               let ind = text.indexOf('-')
               let str1 = text.substring(1, ind)
               let str2 = text.substring(ind + 1)
               d1 = parseFloat(str1)
               if (isNaN(d1)) {
                  throw new Error("Not a number")
               }
               d2 = parseFloat(str2)
               if (isNaN(d2)) {
                  throw new Error("Not a number")
               }
               let mid = (d1 + d2) / 2
               return { d1: d1, d2: d2, dt1: mid * 0.1, dt2: mid * 0.1, h: 0 }
            } else {
               // ex: ~125
               q = parseFloat(text.substring(1))
               if (isNaN(q)) {
                  throw new Error("Not a number")
               }
               d1 = q * 0.95
               d2 = q * 1.05
               s1 = q * 0.90
               s2 = q * 1.1
               if (Math.abs(q) < 0.01) {
                  d1 = 0.0
                  d2 = 0.01
                  s1 = 0.0
                  s2 = 0.02
               }
               let dt1 = d1 - s1
               let dt2 = s2 - d2
               return { d1: d1, d2: d2, dt1: dt1, dt2: dt2, h: 0 }
            }
         } else if (text[0] === '>') {
            // ex: >125
            q = parseFloat(text.substring(1))
            if (isNaN(q)) {
               throw new Error("Not a number")
            }
            if (Math.abs(q) < 0.01) {
               q = 0.01
            }
            return { d1: q, d2: Infinity, dt1: 0, dt2: 0, h: 0 }
         } else if (text[0] === '<') {
            // ex: <125
            q = parseFloat(text.substring(1))
            if (isNaN(q)) {
               throw new Error("Not a number")
            }
            return { d1: 0, d2: q, dt1: 0, dt2: 0, h: 0 }
         } else {
            // ex: 125
            q = parseFloat(text)
            if (isNaN(q)) {
               throw new Error("Not a number")
            }
            return { d1: q, d2: q, dt1: 0, dt2: 0, h: 0 }
         }
      } catch (err) {
         return null
      }
   }


   function possibility(P, D) {
      if (P.d1 > D.d2) {
         let interm = D
         D = P
         P = interm
      } else if (D.d1 <= P.d2) {
         return 1
      }
      if (test1(P.h, D.h, D.d1, D.dt1, P.d2, P.dt2)) {
         return Math.max(P.h, D.h)
      }
      return inters1(P.h, D.h, D.d1, D.dt1, P.d2, P.dt2)
   }
   
   
   function necessity(P, D) {
      if (1. - P.h <= D.h) {
         return P.h
      }
      let alph1 = alpha1(P.h, D.h, P.d1, D.d1, P.dt1, D.dt1)
      if (alph1 == 1. - P.h) {
         return P.h
      }
      let alph2 = alpha2(P.h, D.h, P.d2, D.d2, P.dt2, D.dt2)
      return 1. - Math.max(alph1, alph2)
   }
   
   function test1(h, h_, d1_, dt1_, d2, dt2) {
      return (1. - h) * (d1_ - dt1_ - d2) - (1. - h_) * dt2 >= 0
   }
   
   function inters1(h, h_, d1_, dt1_, d2, dt2) {
      return 1. - (1. - h) * (1. - h_) * (d1_ - d2) / ((1. - h) * dt1_ + (1. - h_) * dt2)
   }
   
   function test2(h, h_, d1, d1_, dt1, dt1_) {
      return (1. - h) * (d1_ - dt1_ - d1) + dt1 * h_ >= 0
   }
   
   function test3(h, h_, d1, d1_, dt1, dt1_) {
      return (1. - h_) * (d1_ - d1 + dt1) - dt1_ * h >= 0
   }
   
   function inters2(h, h_, d1, d1_, dt1, dt1_) {
      return (1. - h) * ((1. - h_) * (d1 - d1_) + dt1_) / ((1. - h) * dt1_ + (1. - h) * dt1)
   }
   
   function test4(h, h_, d2, d2_, dt2, dt2_) {
      return (1. - h_) * (d2 + dt2 - d2_) - dt2_ * h_ < 0
   }
   
   function test5(h, h_, d2, d2_, dt2, dt2_) {
      return (1. - h) * (d2 - d2_ - dt2_) + h_ * dt2 >= 0
   }
   
   function inters3(h, h_, d2, d2_, dt2, dt2_) {
      return (1. - h) * ((1. - h_) * (d2_ - d2) + dt2_) / ((1. - h_) * dt2 + (1. - h) * dt2_)
   }
   
   function alpha1(h, h_, d1, d1_, dt1, dt1_) {
      if (test2(h, h_, d1, d1_, dt1, dt1_)) {
         return h_
      }
      if (test3(h, h_, d1, d1_, dt1, dt1_)) {
         return inters2(h, h_, d1, d1_, dt1, dt1_)
      }
      return 1. - h
   }
   
   function alpha2(h, h_, d2, d2_, dt2, dt2_) {
      if (test4(h, h_, d2, d2_, dt2, dt2_)) {
         return 1. - h
      }
      if (test5(h, h_, d2, d2_, dt2, dt2_)) {
         return h_
      }
      return inters3(h, h_, d2, d2_, dt2, dt2_)
   }
   
})()




// WEBPACK FOOTER //
// ./src/utilities/fuzzy.js